import { Text, View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import type { ReportHeader } from '../../../../../types/reportSection'
import { HeaderCellStyles } from '../../../styles/HeaderCellStyles'

export const HeaderRow = ({ symbol, title }: ReportHeader) => {
  const { row, headerRow, headerText } = commonPdfTableStyles
  const { symbolCell, symbolCellText, mainGroupCell } = HeaderCellStyles

  return (
    <View style={[row, headerRow]}>
      {symbol && (
        <View style={symbolCell}>
          <Text style={[headerText, symbolCellText]}>{symbol}</Text>
        </View>
      )}
      <View style={mainGroupCell}>
        <Text style={headerText}>{title}</Text>
      </View>
    </View>
  )
}
